import { camelizeKeys } from 'humps';

import { getConfig } from '../ConfigurationService';
import { Configuration } from '../ConfigurationService/ConfigurationService';
import { appRoot } from '../UrlGeneratorService/UrlGeneratorService';

const getAccessToken = async () => {
  const response = await fetch(`${appRoot()}/oauth2/access_token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      grant_type: getConfig(Configuration.OauthSessionGrantType),
      client_id: getConfig(Configuration.OauthClientId),
      client_secret: getConfig(Configuration.OauthClientSecret),
    }),
  });

  const json = await response.json();

  return camelizeKeys(json);
};

export const authorize = getAccessToken;
